/**
 * @generated SignedSource<<ca0f26bd1e860836edc08269fd864af1>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type Price_viewer$data = {
  readonly originalListPriceSearchBrowseFF: boolean | null;
  readonly " $fragmentType": "Price_viewer";
};
export type Price_viewer$key = {
  readonly " $data"?: Price_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"Price_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "Price_viewer",
  "selections": [
    {
      "alias": "originalListPriceSearchBrowseFF",
      "args": [
        {
          "kind": "Literal",
          "name": "feature",
          "value": "originalListPriceSearchBrowse"
        }
      ],
      "kind": "ScalarField",
      "name": "featureFlag",
      "storageKey": "featureFlag(feature:\"originalListPriceSearchBrowse\")"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "dab46bf26a8eb3c10ffa307d8b87cb8f";

export default node;
